import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Channels from "@/pages/Channels";
import Contacts from "@/pages/Contacts";
import Templates from "@/pages/Templates";
import Conversations from "@/pages/Conversations";
import Messages from "@/pages/Messages";
import AccessTokens from "@/pages/AccessTokens";
import Autopilots from "@/pages/Autopilots";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminChannels from "@/pages/admin/AdminChannels";
import AdminTemplates from "@/pages/admin/AdminTemplates";
import AdminMessages from "@/pages/admin/AdminMessages";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F5F7]">
        <Loader2 className="w-6 h-6 animate-spin text-[#0F172A]" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user && user !== null) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/channels" element={<Channels />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/conversations" element={<Conversations />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/access-tokens" element={<AccessTokens />} />
              <Route path="/autopilots" element={<Autopilots />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/channels" element={<AdminChannels />} />
              <Route path="/admin/templates" element={<AdminTemplates />} />
              <Route path="/admin/messages" element={<AdminMessages />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
